/** Checkbox states */
export const ALWAYS_ON = "ALWAYS_ON";
export const DISABLED = "DISABLED";

/** Channels */
export const EMAIL = "EMAIL";
export const DIGEST = "DIGEST";
export const INAPP = "INAPP";

/** Intervals */
const EVERY_MORNING = "EVERY_MORNING";
const EVERY_MIDDAY = "EVERY_MIDDAY";
const EVERY_AFTERNOON = "EVERY_AFTERNOON";
const EVERY_MONDAY = "EVERY_MONDAY";
const EVERY_WEDNESDAY = "EVERY_WEDNESDAY";
const EVERY_FRIDAY = "EVERY_FRIDAY";
const EVERY_FORTNIGHT = "EVERY_FORTNIGHT";
export const NEVER = "NEVER";

/* Notification trigger events */
const SECURITY_PW_CHANGE = "SECURITY_PW_CHANGE";
const SECURITY_BLOCKED = "SECURITY_BLOCKED";
const DOCUMENT_ADD_USER = "DOCUMENT_ADD_USER";
const DOCUMENT_ADD_GROUP = "DOCUMENT_ADD_GROUP";
const DOCUMENT_WORKFLOWSTAGE_CHANGE = "DOCUMENT_WORKFLOWSTAGE_CHANGE";
const EXPORT_COMPLETE = "EXPORT_COMPLETE";
const DOCUMENT_CHANGE = "DOCUMENT_CHANGE";
const HEADING_CHANGE = "HEADING_CHANGE";
const HEADING_WORKFLOWSTAGE_CHANGE = "HEADING_WORKFLOWSTAGE_CHANGE";
const COMMENT_ADD = "COMMENT_ADD";
const SECURITY_ALL = "SECURITY_ALL";
const COMMENT_ALL = "COMMENT_ALL";
const DOCUMENT_ALL = "DOCUMENT_ALL";

export const notificationSettingsOptions = {
    channels: [ INAPP, EMAIL, /*DIGEST*/],
    digestIntervals: [
        NEVER,
        EVERY_MORNING,
        EVERY_MIDDAY,
        EVERY_AFTERNOON,
        EVERY_MONDAY,
        EVERY_WEDNESDAY,
        EVERY_FRIDAY,
        EVERY_FORTNIGHT,
    ],
    fixedStates: [
        ALWAYS_ON,
        DISABLED,
        EVERY_MORNING,
        EVERY_MIDDAY,
        EVERY_AFTERNOON,
        EVERY_MONDAY,
        EVERY_WEDNESDAY,
        EVERY_FRIDAY,
        EVERY_FORTNIGHT,
        NEVER,
    ],
    types: [
        SECURITY_PW_CHANGE,
        SECURITY_BLOCKED,
        DOCUMENT_ADD_USER,
        DOCUMENT_ADD_GROUP,
        DOCUMENT_WORKFLOWSTAGE_CHANGE,
        EXPORT_COMPLETE,
        DOCUMENT_CHANGE,
        HEADING_CHANGE,
        HEADING_WORKFLOWSTAGE_CHANGE,
        COMMENT_ADD,
        SECURITY_ALL,
        DOCUMENT_ALL,
        COMMENT_ALL
    ],
    // eslint-disable-next-line sort-keys
    fixedValues: [
        {
            type: SECURITY_PW_CHANGE,
            channel: EMAIL,
            fixedState: ALWAYS_ON,
        },
        { type: SECURITY_PW_CHANGE, channel: INAPP, fixedState: DISABLED },
        { type: COMMENT_ADD, channel: DIGEST, fixedState: NEVER },
        { type: SECURITY_ALL, channel: EMAIL, fixedState: ALWAYS_ON },
        { type: DOCUMENT_ALL, channel: INAPP, fixedState: ALWAYS_ON },
        { type: COMMENT_ALL, channel: INAPP, fixedState: ALWAYS_ON },
    ],
};

const convertFixedVal = {
    [ALWAYS_ON]: true,
    [DISABLED]: false
};

export const generateSettingsKeys =
    notificationSettingsOptions.types
        .map(type =>
            notificationSettingsOptions.channels.map(channel => {
                const key = `${type}_${channel}`;
                const maybeFixedVal = notificationSettingsOptions.fixedValues.find(
                    ({ type: fixedType, channel: fixedChannel }) => type === fixedType && channel === fixedChannel
                )?.fixedState;
                const maybeValidFixedVal = (maybeFixedVal && channel !== "DIGEST") ? convertFixedVal[maybeFixedVal] : maybeFixedVal;
                return [ key, maybeValidFixedVal ];
            })
        )
        .flat();

// const schema = {
//     type: "object",
//     properties: {
//         channels: {
//             type: "array",
//             items: {
//                 type: "string",
//             },
//             description: "Available channels for notifications to be send via"
//         },
//         fixedStates: {
//             type: "array",
//             items: {
//                 type: "string",
//             },
//             description: "Forced states for checkboxes"
//         },
//         digestIntervals: {
//             type: "array",
//             items: {
//                 type: "string",
//             },
//             description: "List of available intervals for digest notifications"
//         },
//         types: {
//             type: "array",
//             items: {
//                 type: "string",
//                 pattern: "^[A-Z_]+$"
//             },
//             description: "List of available notification triggers/events"
//         },
//         fixedValues: {
//             type: "array",
//             items: {
//                 type: "object",
//                 properties: {
//                     channel: {
//                         enum: { $data: "#/types" },
//                         description: "Notification channel to overwrite checked state for"
//                     },
//                     fixedState:  {
//                         enum: { $data: "#/fixedStates" },
//                         description: "Overwritten checked state for this notification type and channel"
//                     },
//                     type: {
//                         enum: { $data: "#/channels" },
//                         description: "Notification type to be overwritten with checked state"
//                     },
//                 }
//             },
//             description: "List of overwrites for forcing notifications to always have a certain checked state"
//         }
//     },

// };
